module.exports = __webpack_public_path__ + "img/Dantam Hair 41.b4f6b662.jpg";